export default __webpack_public_path__ + "static/lobby2-9dd69221074eb0a1b4b82e1791f7e13b.gif";